import React from "react";

const PrivacyPolicyEyeary = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>개인정보 처리방침</h1>

      <h2 style={styles.h2}>I. 에덴룩스의 개인정보 보호 약속</h2>
      <p>
        에덴룩스는 귀하의 개인정보를 보호하는 일을 매우 엄중하게 받아들이고 있습니다.
        당사의 제품은 귀하가 눈 건강 상태의 중요한 측면들을 추적할 수 있도록 설계되었습니다.
        당사는 건강 데이터보다 더 개인적인 정보는 없다는 점을 잘 알고 있습니다.
        그렇기에 귀하의 개인정보에 대한 통제권은 반드시 귀하에게 있어야 한다고 굳게 믿습니다.
        본 개인정보 처리방침(이하 “방침”)은 귀하가 자신의 개인정보를 직접 관리하고,
        건강 증진의 주도권을 갖는 데 필요한 정보를 제공하기 위해 마련되었습니다.
        본 방침을 주의 깊게 검토해 주시기 바랍니다.
      </p>

      <h2 style={styles.h2}>II. 본 개인정보 처리방침에 대하여</h2>
      <p>
        본 방침은 아이어리(Eyeary) 및 에덴룩스(Edenlux Corp.)의 개인정보 처리에 적용됩니다.
        이어리 서비스를 이용하실 때는 아이어리 앱을 함께 사용해 주세요.
      </p>

      <h2 style={styles.h2}>III. 아이어리는 왜 귀하의 개인정보를 처리하나요?</h2>

      <h3 style={styles.h3}>A. 기기 및 애플리케이션 이용자</h3>

      <h4 style={styles.h4}>i. 처리 목적</h4>
      <ul>
        <li><strong>서비스 제공:</strong> 개인별 눈 상태 데이터 및 맞춤형 인사이트 제공</li>
        <li><strong>고객 서비스:</strong> 문의 응대 및 계정 관련 문제 해결</li>
        <li><strong>프라이버시 보호:</strong> 익명화 및 집계 데이터 활용</li>
        <li><strong>서비스 개선:</strong> 사용 행태 분석 및 기능 개발</li>
        <li><strong>분석 수행:</strong> 사용자 웰빙 및 수행 능력 분석</li>
        <li><strong>마케팅 서비스:</strong> 광고 및 마케팅 정보 제공 (거부 가능)</li>
        <li><strong>법적 의무 준수:</strong> 회계, 세무 및 법적 요구사항 대응</li>
      </ul>

      <h4 style={styles.h4}>ii. 수집 데이터 항목 및 출처</h4>
      <ul>
        <li><strong>연락처 정보:</strong> 이메일 주소</li>
        <li><strong>사용자 정보:</strong> 성별, 생년월일, 사용자 ID 등</li>
        <li><strong>기기 정보:</strong> IP 주소 및 위치 데이터</li>
        <li><strong>활동 및 맥락 정보:</strong> 앱 내 기록, 메모, 피드백</li>
        <li><strong>비의료 데이터:</strong> 눈 상태 기반 웰빙 정보</li>
      </ul>

      <div style={styles.note}>
        <strong>주의:</strong> 건강 관련 데이터는 민감 정보로 분류될 수 있으며,
        명시적 동의가 있는 경우에만 처리됩니다. GPS 위치 정보도 동의 후 수집되며,
        언제든 비활성화할 수 있습니다.
      </div>

      <h3 style={styles.h3}>B. 온라인 고객 및 사이트 방문자</h3>

      <h4 style={styles.h4}>i. 처리 목적</h4>
      <ul>
        <li>서비스 제공 및 사이트 운영</li>
        <li>주문 처리 및 배송 관리</li>
        <li>고객 문의 응대</li>
        <li>사이트 개선 및 UX 분석</li>
        <li>광고 및 마케팅</li>
      </ul>

      <h4 style={styles.h4}>ii. 처리 데이터 및 출처</h4>
      <ul>
        <li>성명, 이메일, 배송지</li>
        <li>결제 정보</li>
        <li>IP 주소 및 방문 기록</li>
        <li>브라우징 패턴</li>
      </ul>

      <h3 style={styles.h3}>C. 데이터 공유 및 전송</h3>
      <p>
        에덴룩스는 개인정보를 판매하거나 대여하지 않습니다. 다음과 같은 파트너와만 공유합니다:
      </p>
      <ul>
        <li>클라우드 및 데이터 저장 서비스</li>
        <li>고객 서비스 및 마케팅 관리</li>
        <li>서비스 분석 도구</li>
      </ul>

      <h2 style={styles.h2}>IV. 데이터 보호 조치</h2>
      <p>
        아이어리는 익명화, 가명화, 접근 제어, 암호화 등 다양한 보호 조치를 적용합니다.
        정기적인 보안 교육 및 시스템 점검을 수행합니다.
      </p>

      <h2 style={styles.h2}>V. 데이터 보관 기간</h2>
      <p>
        개인정보는 계정 유지 기간 동안 보관되며, 목적 달성 후 삭제됩니다.
        단, 법적 의무가 있는 경우 해당 기간 동안 보관됩니다.
      </p>
      <p>
        계정 삭제 요청: <strong>eyeary@edenlx.com</strong>
      </p>

      <h2 style={styles.h2}>VI. 쿠키 사용</h2>
      <p>
        사이트 최적화 및 마케팅을 위해 쿠키를 사용합니다.
        쿠키는 사용자 기기에 해를 끼치지 않는 작은 텍스트 파일입니다.
      </p>

      <h2 style={styles.h2}>VII. 정보주체의 권리</h2>
      <ul>
        <li>접근권</li>
        <li>삭제권</li>
        <li>정정권</li>
        <li>데이터 이식권</li>
        <li>처리 반대권</li>
        <li>동의 철회권</li>
      </ul>
      <p>문의: <strong>eyeary@edenlx.com</strong></p>

      <h2 style={styles.h2}>VIII. 개인정보 관리책임자 연락처</h2>
      <p>
        <strong>에덴룩스 (Edenlux Corp.)</strong><br />
        이메일: eyeary@edenlx.com<br />
        주소: 서울특별시 금천구 가산디지털1로 145, 1704호<br />
        개인정보 보호책임자: eyeary@edenlx.com
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.6,
    color: "#333",
  },
  h1: {
    fontSize: "28px",
    marginBottom: "20px",
  },
  h2: {
    fontSize: "22px",
    marginTop: "30px",
  },
  h3: {
    fontSize: "18px",
    marginTop: "20px",
  },
  h4: {
    fontSize: "16px",
    marginTop: "15px",
  },
  note: {
    backgroundColor: "#f8f8f8",
    padding: "15px",
    borderLeft: "4px solid #ccc",
    margin: "20px 0",
  },
};

export default PrivacyPolicyEyeary;